/* import __COLOCATED_TEMPLATE__ from './about-phone-number-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();